import React from "react";
import DisplayCardList from "../../componenets/DisplayCardList";
import { formData } from "../../data";

const FormHome = () => {
  return <DisplayCardList data={formData} />;
};

export default FormHome;
